module.exports = __webpack_public_path__ + "media/6-e.f6ebf633.wav";